// @flow
import React from 'react';
import getRoutes from './routes';
import App from './containers/App';

const mapRoutesForUse = (
  routes,
  jpApiClient,
  apolloClient,
  getState,
  dispatch,
  authPromise,
  injectReducer
) =>
  routes.map((item) => {
    const { path: itemPath, children, element, loader, action } = item;

    const Element = element;

    return {
      path: itemPath,
      element: element ? <Element /> : null,
      loader: loader
        ? ({ params, request }) =>
            loader({
              params,
              request,
              jpApiClient,
              apolloClient,
              getState,
              dispatch,
              authPromise,
              injectReducer
            })
        : null,
      action: action || (() => null),
      children: children && mapRoutesForUse(children)
    };
  });

export default ({
  jpApiClient,
  apolloClient,
  getState,
  dispatch,
  authPromise,
  injectReducer
}) => {
  const routes = getRoutes();
  const browserRoutes = mapRoutesForUse(
    routes,
    jpApiClient,
    apolloClient,
    getState,
    dispatch,
    authPromise,
    injectReducer
  );

  return [
    {
      element: <App />,
      children: browserRoutes
    }
  ];
};
